import { string } from 'prop-types';
import React from 'react';

import Editorial from 'shared/components/content/Editorial';
import HTMLContent from 'shared/components/HTMLContent';

import image from '../../../images/frontpage/home4.png';
import Article from './Article';

const Article4 = ({ title, body }) => (
  <Article index="4">
    <div className="article-content">
      <div className="article-content__1">
        <h1>{title}</h1>
        <Editorial>
          <HTMLContent content={body} />
        </Editorial>
      </div>
      <div className="article-content__2">
        <img alt="" src={image} />
      </div>
    </div>
  </Article>
);

Article4.propTypes = {
  title: string.isRequired,
  body: string,
};

export default Article4;
